import {createContext, useContext} from "react";
import type Combatant from "@/encounter/model/Combatant.ts";
import type {AreaEffect} from "@/encounter/model/AreaEffect.ts";

export type TableTopSelection =
    | {type: "combatants"; ids: string[]}
    | {type: "areaEffect"; id: string}
    | undefined;

export type TableTopSelectionReturn = {
    selectedCombatants: Combatant[];
    selectedEffect?: AreaEffect;
    isCombatantSelected: (combatant: Combatant) => boolean;
    isAreaEffectSelected: (effect: AreaEffect) => boolean;
    selectCombatants: (combatants: Combatant[]) => void;
    selectAreaEffect: (effect: AreaEffect) => void;
    clearSelection: () => void;
}

export const TableTopSelectionContext = createContext<TableTopSelectionReturn | null>(null);

export function useTableTopSelection(): TableTopSelectionReturn {
    const context = useContext(TableTopSelectionContext);
    if (!context) {
        throw new Error("useTableTopSelection must be used within a TableTopSelectionProvider");
    }
    return context;
}
